import type { ComponentProps } from 'react';
import { today, toStringDate } from '@gov-nx/utils/common';
import type { FormInputProps } from './FormInput';
import { FormInput } from './FormInput';

// @ts-expect-error Returing null means that the value is cleared
const toValue: ComponentProps<typeof FormInput<Date>>['toValue'] = (event) => {
	if (event == null) {
		return undefined;
	}
	const isCleared = event.currentTarget.value === '';
	if (isCleared) {
		return null;
	}

	return today(event.currentTarget.value);
};

const DEFAULT_MAX_DATE = '9999-12-31';

export const FormDatePicker = (props: FormInputProps) => (
	<FormInput<Date>
		{...props}
		field={{ size: 'm', max: DEFAULT_MAX_DATE, ...props.field, type: 'date' }}
		toValue={toValue}
		fromValue={(date) => (date ? toStringDate(date) : '')}
	/>
);
